// eslint-disable-next-line import/prefer-default-export
export const COLORS = {
  PURPLE: '#5009B5',
  BRIGHT_GREEN: '#22CC0D',
  GREEN: '#048802',
  LIGHT_GREEN: '#EDFFEA',
  RED: '#FF4848',
};
